import { render, staticRenderFns } from "./CommonBtnAction.vue?vue&type=template&id=2a8c4d13"
import script from "./CommonBtnAction.vue?vue&type=script&lang=js"
export * from "./CommonBtnAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports